import { ClockTypes, RegisterFunctions } from "@repo/database";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import type { Table } from "~/providers/table-provider";
import { useOrder } from "~/hooks/use-order";
import { useUser } from "~/hooks/use-user";
import { useFunctionManager } from "~/managers/use-function-manager";
import { useOrderManager } from "~/managers/use-order-manager";
import { RegisterButton } from "../ui/register-button";
import { Separator } from "../ui/separator";

export default function TableContext({
  table,
  onClose,
}: {
  table: Table;
  onClose: () => void;
}) {
  const { t } = useTranslation("common");

  const { orders } = useOrder();

  const { user } = useUser();

  const { openOrderTransfer, updateOrder } = useOrderManager();

  const { getDefaultColor, getLabel } = useFunctionManager();

  const orderOnTable = orders.find((o) => o.tableId === table.id);

  const handleProforma = async () => {
    await updateOrder({
      printProforma: true,
      order: orderOnTable,
    });
    onClose();
  };

  const handleTransfer = () => {
    openOrderTransfer(orderOnTable);
    onClose();
  };

  return (
    <div className="flex flex-col gap-4">
      <RegisterButton
        color={getDefaultColor(RegisterFunctions.print_preliminary_receipt)}
        className="text-xl w-full"
        disabled={!orderOnTable}
        onPointerDown={handleProforma}
      >
        {getLabel(RegisterFunctions.print_preliminary_receipt)}
      </RegisterButton>
      <RegisterButton
        className="text-xl w-full"
        disabled={!orderOnTable}
        onPointerDown={handleTransfer}
      >
        {t("transfer")}
      </RegisterButton>
      {/* <RegisterButton
        className="text-xl w-full"
        disabled={!orderOnTable}
        onPointerDown={handleTransfer}
      >
        History
      </RegisterButton> */}
      <Separator />
      {orderOnTable && (
        <div className="gap-1 flex flex-col">
          <span className="text-center">
            {t("Order.started_at", {
              date: format(
                orderOnTable.createdAt,
                user.clock === ClockTypes.military
                  ? "dd-MM-yyyy HH:mm"
                  : "MM/dd/yyyy hh:aa a",
              ),
            })}
          </span>
          <span className="text-center">
            {t("Order.updated_at", {
              date: format(
                orderOnTable.updatedAt,
                user.clock === ClockTypes.military
                  ? "dd-MM-yyyy HH:mm"
                  : "MM/dd/yyyy hh:aa a",
              ),
            })}
          </span>
        </div>
      )}
    </div>
  );
}
